import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-27 17:29:06
 * @LastEditTime: 2022-01-13 15:05:12
 * @LastEditors: wangshengqiang
 * @Description: 保险起期
 */
import React from 'react';
import moment from 'moment';
import RowDate from '../RowDate';

const WeddingReceptionDate = props => {
  const {
    attrs,
    form,
    formKey,
    defaultValue
  } = props;
  const {
    display = {}
  } = attrs || {};
  const min = moment().add(1, 'days').format('YYYY-MM-DD');
  const max = moment().add(80, 'years').format('YYYY-MM-DD');
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RowDate, _extends({}, props, {
    min: min,
    max: max
  })));
};

export default WeddingReceptionDate;